import Subtitle from "../../Subtitle";
import Title from "../../Title";
import BasicText from "../../BasicText";
import ProjectSlide from "../../ProjectSlide";
import { PORTFOLIO } from "@/data/portfolio";

function OurProjects() {
  return (
    <div className="w-full xl:w-[1200px] flex flex-col relative gap-[86px] px-4 sm:px-10 md:px-11 lg:px-12 xl:px-0">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-[20px]">
        <div className="flex flex-col gap-[10px]">
          <Subtitle>
          // Portfolio
          </Subtitle>
          <Title className='pb-[25px] text-[25px] xl:text-[40px] max-w-[290px]'>
            <span>The&nbsp;</span>
            <span className="text-luminode-blue">Recent Projects&emsp;</span>
            <span>we worked on.</span>
          </Title>
        </div>
        <BasicText className='text-[12px] xl:text-[16px] tracking-tighter max-w-[300px]' color="faded">
          <span>A selection of the products we&apos;ve designed and built for partners across web2 and web3.</span>
        </BasicText>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-[40px] gap-y-[70px]">
        {PORTFOLIO.map((project) => (
          <ProjectSlide key={project.link} {...project} />
        ))}
      </div>
    </div>
  )
}

export default OurProjects;
